export type NavSide = 'left' | 'right';

// localStorage. The floating drawing toolbar's drag offset is a different key in sessionStorage:
// `config.toolbar.drawingTools.position` (shared/classroom/toolbar/data-access: toolbar-config-session-storage.ts).
const storageKey = 'config.toolbar.side';

export const getStoredNavSide = (): NavSide => {
    try {
        return localStorage.getItem(storageKey) === 'left' ? 'left' : 'right';
    } catch (error) {
        // storage not available (private mode / blocked): fall back to the default side
        console.error(`Beamer nav side not read from localStorage "${storageKey}", using "right"`, error);
        return 'right';
    }
};

export const updateStoredNavSide = (side: NavSide) => {
    try {
        localStorage.setItem(storageKey, side);
    } catch (error) {
        // storage not available (private mode / blocked): the side is kept in memory only
        console.error(`Beamer nav side "${side}" not saved to localStorage "${storageKey}"`, error);
    }
};
